module.exports = __webpack_public_path__ + "img/20250220-01-02.3496adeb.png";